var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInscription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0C43.464 0 56 12.6174 56 28.1818C56 29.7383 54.7464 31 53.2 31C51.6536 31 50.4 29.7383 50.4 28.1818C50.4 15.7303 40.3712 5.63636 28 5.63636C15.6288 5.63636 5.6 15.7303 5.6 28.1818C5.6 29.7383 4.3464 31 2.8 31C1.2536 31 0 29.7383 0 28.1818C0 12.6174 12.536 0 28 0Z",
    transform: "translate(6 53)",
    id: "Path",
    fill: "#07A5DF",
    className: "fill-primary-color",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "matrix(0.70710677 0.70710677 -0.70710677 0.70710677 31.34938 18.493254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0599267 22.5362C2.62713 25.9312 6.69921 28.125 11.2837 28.125C19.0502 28.125 25.3462 21.829 25.3462 14.0625C25.3462 6.296 19.0502 0 11.2837 0C8.09554 0 5.1552 1.06093 2.79644 2.849C1.73685 3.65223 0.794614 4.6022 0 5.66864",
    transform: "translate(5.5913215 0)",
    id: "Path",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#07A5DF",
    className: "stroke-primary-color",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 5.625C4.3658 5.625 5.625 4.3658 5.625 2.8125C5.625 1.2592 4.3658 0 2.8125 0C1.2592 0 0 1.2592 0 2.8125C0 4.3658 1.2592 5.625 2.8125 5.625Z",
    transform: "translate(0 11.25)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none",
    className: "fill-primary-color"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.9102 0C22.9576 0 31 9.06342 31 20.125C31 21.7128 29.754 23 28.2169 23C26.6799 23 25.4339 21.7128 25.4339 20.125C25.4339 12.1328 19.7702 5.75 12.9102 5.75C9.86397 5.75 6.98278 7.00264 4.71379 9.26046C3.60679 10.362 1.84497 10.3279 0.778654 9.18436C-0.287664 8.04079 -0.254685 6.22076 0.852315 5.11921C4.13778 1.84992 8.39277 0 12.9102 0Z",
    transform: "translate(53 62)",
    id: "Path",
    fill: "#07A5DF",
    className: "fill-primary-color",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0ZM11.5 5.75C14.6756 5.75 17.25 8.32436 17.25 11.5C17.25 14.6756 14.6756 17.25 11.5 17.25C8.32436 17.25 5.75 14.6756 5.75 11.5C5.75 8.32436 8.32436 5.75 11.5 5.75Z",
    transform: "translate(56 42)",
    id: "Oval",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0C21.7128 0 23 1.34315 23 3C23 4.53851 21.8901 5.80652 20.4603 5.97982L20.125 6L2.875 6C1.28718 6 0 4.65685 0 3C0 1.46149 1.10987 0.193479 2.53971 0.0201832L2.875 0L20.125 0Z",
    transform: "translate(50 20)",
    id: "Path-7",
    fill: "#0B67B2",
    className: "fill-secondary-color",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0C21.7128 0 23 1.34315 23 3C23 4.53851 21.8901 5.80652 20.4603 5.97982L20.125 6L2.875 6C1.28718 6 0 4.65685 0 3C0 1.46149 1.10987 0.193479 2.53971 0.0201832L2.875 0L20.125 0Z",
    transform: "matrix(-4.371139E-08 1 -1 -4.371139E-08 64.5 11.5)",
    id: "Path-7",
    fill: "#0B67B2",
    className: "fill-secondary-color",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInscription);
export default __webpack_public_path__ + "static/media/inscription.f036f59bc3ce9066ec9cf2258474c1e7.svg";
export { ForwardRef as ReactComponent };